import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const validationMessageTranslationsK = {
  mustHaveAtleast1user: "validation_message_translations.mustHaveAtleast1user",
  mustStartWithAlphabet: "validation_message_translations.mustStartWithAlphabet",
  fileTooLarge: "validation_message_translations.fileTooLarge",
  passwordRequirements: "validation_message_translations.passwordRequirements",
  atleast8Characters: "validation_message_translations.atleast8Characters",
  containNumbers: "validation_message_translations.containNumbers",
  containSpecialCharacters: "validation_message_translations.containSpecialCharacters",
  hasToBetween: "validation_message_translations.hasToBetween",
  mustBeLessThan20Characters: "validation_message_translations.mustBeLessThan20Characters",
  includeUpperandLowercaseLetters: "validation_message_translations.includeUpperandLowercaseLetters",
  emailValidation: "validation_message_translations.emailValidation",
  hasToNotExceedLimit: "validation_message_translations.hasToNotExceedLimit",
  hasToBeEqualTo: "validation_message_translations.hasToBeEqualTo",
  mustBe5CharactersLong: "validation_message_translations.mustBe5CharactersLong",
  invalidValue: "validation_message_translations.invalidValue",
  hasToBeLowerOrEqualTo: "validation_message_translations.hasToBeLowerOrEqualTo",
  hasToBeLowerTo: "validation_message_translations.hasToBeLowerTo",
  fileTypeNotSupported: "validation_message_translations.fileTypeNotSupported",
  mustBeLessThanCharacters: "validation_message_translations.mustBeLessThanCharacters",
};

export const useValidationMessageTranslationsT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      mustHaveAtleast1user: t(validationMessageTranslationsK.mustHaveAtleast1user),
      mustStartWithAlphabet: t(validationMessageTranslationsK.mustStartWithAlphabet),
      fileTooLarge: t(validationMessageTranslationsK.fileTooLarge),
      passwordRequirements: t(validationMessageTranslationsK.passwordRequirements),
      atleast8Characters: t(validationMessageTranslationsK.atleast8Characters),
      containNumbers: t(validationMessageTranslationsK.containNumbers),
      containSpecialCharacters: t(validationMessageTranslationsK.containSpecialCharacters),
      hasToBetween: t(validationMessageTranslationsK.hasToBetween),
      mustBeLessThan20Characters: t(validationMessageTranslationsK.mustBeLessThan20Characters),
      includeUpperandLowercaseLetters: t(validationMessageTranslationsK.includeUpperandLowercaseLetters),
      emailValidation: t(validationMessageTranslationsK.emailValidation),
      hasToNotExceedLimit: t(validationMessageTranslationsK.hasToNotExceedLimit),
      hasToBeEqualTo: (otherField: string) => t(validationMessageTranslationsK.hasToBeEqualTo, { otherField }),
      mustBe5CharactersLong: t(validationMessageTranslationsK.mustBe5CharactersLong),
      invalidValue: t(validationMessageTranslationsK.invalidValue),
      hasToBeLowerOrEqualTo: (otherField1: string, otherField2: string) => t(validationMessageTranslationsK.hasToBeLowerOrEqualTo, { otherField1, otherField2 }),
      hasToBeLowerTo: (otherField1: string, otherField2: string) => t(validationMessageTranslationsK.hasToBeLowerTo, { otherField1, otherField2 }),
      fileTypeNotSupported: t(validationMessageTranslationsK.fileTypeNotSupported),
      mustBeLessThanCharacters: (length: string) => t(validationMessageTranslationsK.mustBeLessThanCharacters, { length }),
    }),
    [i18n.language]
  );
};